var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Metamask = /** @class */ (function () {
    function Metamask() {
    }
    Metamask.hasWeb3 = function () {
        return typeof (window === null || window === void 0 ? void 0 : window['ethereum']) !== 'undefined';
    };
    Metamask.isMetamask = function () {
        var _a, _b;
        return (_b = (_a = window === null || window === void 0 ? void 0 : window['ethereum']) === null || _a === void 0 ? void 0 : _a['isMetamask']) !== null && _b !== void 0 ? _b : false;
    };
    Metamask.getProvider = function () {
        return (window === null || window === void 0 ? void 0 : window['ethereum']) || (window === null || window === void 0 ? void 0 : window['web3']);
    };
    Metamask.enable = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestAccounts()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Listening for all events specified in EIP 1193 .
     * @param event event name, like 'accountsChanged', 'chainChanged'
     * @param callback Callback
     */
    Metamask.on = function (event, callback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.getProvider().on(event, callback);
                return [2 /*return*/];
            });
        });
    };
    /**
     * @returns Returns an array of accounts, currently only one account would be returned.
     */
    Metamask.requestAccounts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accounts, error_1, accounts, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (window === null || window === void 0 ? void 0 : window['ethereum'].enable())];
                    case 1:
                        accounts = _a.sent();
                        return [2 /*return*/, accounts];
                    case 2:
                        error_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, (window === null || window === void 0 ? void 0 : window['ethereum'].send('eth_requestAccounts'))];
                    case 4:
                        accounts = _a.sent();
                        return [2 /*return*/, accounts];
                    case 5:
                        error_2 = _a.sent();
                        return [2 /*return*/, []];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Send transaction
     * @param params
     * @returns Returns a transaction hash if succeeded, empty string if failed.
     */
    Metamask.sendTransaction = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        var _a;
                        try {
                            (_a = window === null || window === void 0 ? void 0 : window['ethereum']) === null || _a === void 0 ? void 0 : _a.send({
                                method: 'eth_sendTransaction',
                                params: [params],
                                from: params.from
                            }, function (err, result) {
                                var _a;
                                if (err) {
                                    resolve('');
                                    return;
                                }
                                resolve((_a = result === null || result === void 0 ? void 0 : result.result) !== null && _a !== void 0 ? _a : '');
                            });
                        }
                        catch (error) {
                            resolve('');
                        }
                    })];
            });
        });
    };
    /**
     * Get the balance of specified address
     * @param address
     * @returns Balance hex string in wei
     */
    Metamask.getBalance = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var addr, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(address !== null && address !== void 0)) return [3 /*break*/, 1];
                        _a = address;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.requestAccounts()[0]];
                    case 2:
                        _a = (_b.sent());
                        _b.label = 3;
                    case 3:
                        addr = _a;
                        if (!addr) {
                            return [2 /*return*/, '0x00'];
                        }
                        return [2 /*return*/, new Promise(function (resolve) {
                                var _a;
                                try {
                                    (_a = window === null || window === void 0 ? void 0 : window['ethereum']) === null || _a === void 0 ? void 0 : _a.send({ method: 'eth_getBalance', params: [addr, 'latest'] }, function (err, result) {
                                        var _a;
                                        if (err) {
                                            resolve('0x00');
                                            return;
                                        }
                                        resolve((_a = result === null || result === void 0 ? void 0 : result.result) !== null && _a !== void 0 ? _a : '0x00');
                                    });
                                }
                                catch (_b) {
                                    resolve('0x00');
                                }
                            })];
                }
            });
        });
    };
    return Metamask;
}());
export default Metamask;
//# sourceMappingURL=data:application/json;base64,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